import fs from 'node:fs'
import path from 'node:path'

export function listExtractNames(
  cwd: string,
  dirPath: string,
  ignored = new Set<string>()
): string[] {
  const fullDir = path.join(cwd, ...dirPath.split('/'))
  if (!fs.existsSync(fullDir)) {
    return []
  }

  return fs
    .readdirSync(fullDir)
    .filter((fileName) => fileName.endsWith('.ts'))
    .map((fileName) => fileName.replace(/\.ts$/, ''))
    .filter((name) => !ignored.has(name))
    .sort()
}
